import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { isError } from "@nju/result";
import { IPaymentMethodType, IRegisterPaymentResult } from "./types";
import { serverResponse } from "./validators";

interface IParams {
  // userId: string;
  orchestratorId: string;
  paymentMethod: IPaymentMethodType;
}

export async function registerPayment({
  paymentMethod,
  orchestratorId,
}: IParams): Promise<IRegisterPaymentResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/orchestrators/${orchestratorId}/actions/PAYMENT_METHOD_SET`,
    {
      method: "post",
      validator: serverResponse,
      json: {
        methodType: paymentMethod,
        channel: "WEB",
      },
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
    },
  );

  if (isError(result)) {
    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
